import { Route } from '@/typings/router';

/*
 * Note:
 * Menu items with children need to set a key starting with "/"
 * @see https://github.com/umijs/route-utils/blob/master/src/transformRoute/transformRoute.ts#L219
 */

const menus: Route[] = [
  {
    path: '/',
    name: 'Home',
    icon: 'home',
  },
];

export { menus };
export * from './menuEstudiante';
export * from './menuAsesor';
export * from './menuCoordinador';
